var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map, List } from 'immutable';

import { t } from "../../I18N";
import formater from "../../Metadata/helpers/formater";
import { Icon } from "../../UI";

const conformQuote = (text) => /*#__PURE__*/
_jsx("div", { className: "relationship-quote" }, void 0, /*#__PURE__*/
_jsx("span", { className: "quoteIconStart" }, void 0, /*#__PURE__*/
_jsx(Icon, { icon: "quote-left" })
),
text, /*#__PURE__*/
_jsx("span", { className: "quoteIconEnd" }, void 0, /*#__PURE__*/
_jsx(Icon, { icon: "quote-right" })
)
);


const conformDl = ({ label, name, value }) => /*#__PURE__*/
_jsx("dl", { className: "item-property-default" }, name, /*#__PURE__*/
_jsx("dt", {}, void 0, label), /*#__PURE__*/
_jsx("dd", {}, void 0, Array.isArray(value) ? value.map((v) => v.value).join(', ') : value)
);








const extendedMetadata = (relationship, text, relationTypes, thesauris) => {
  const formattedMetadata = formater.prepareMetadata(
    relationship.toJS(),
    relationTypes,
    thesauris
  ).metadata;
  return (/*#__PURE__*/
    _jsx("div", { className: "relationship-metadata" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "item-metadata" }, void 0,
    formattedMetadata.map(conformDl),
    text &&
    conformDl({
      label: t('System', 'Text'),
      name: 'text',
      value: conformQuote(text)
    })
    )
    ));

};

const justText = (text) => /*#__PURE__*/_jsx("div", { className: "relationship-metadata" }, void 0, conformQuote(text));

const HubRelationshipMetadata = (props) => {
  const { relationship, relationTypes, thesauris } = props;
  const text = relationship.getIn(['reference', 'text']);
  const metadata = relationship.get('metadata');

  if (metadata && metadata.size) {
    return extendedMetadata(relationship, text, relationTypes, thesauris);
  }

  if (text) {
    return justText(text);
  }

  return null;
};

HubRelationshipMetadata.defaultProps = {
  relationship: Map({})
};







export function mapStateToProps({ relationTypes, thesauris }) {
  return { relationTypes, thesauris };
}

export default connect(mapStateToProps)(HubRelationshipMetadata);